import Box from '@mui/material/Box';
import Footer from '../../containers/HomePage/Footer';
import AppDownloadHeader from './AppDownloadHeader';
import AppDownloadMainInfo from './AppDownloadMainInfo';

export function AppDownloadPage() {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppDownloadHeader />
      <Box sx={{ flex: 1 }}>
        <AppDownloadMainInfo />
      </Box>
      <Footer />
    </Box>
  );
}
